export default __webpack_public_path__ + "static/penisMb-3d640685368525da9579c049a3adbce3.png";